import Axios from '@/plugins/Axios';

import { Doctor } from '@/types';

const endpoint = '/consultation/doctor';

const doctorApi = {
  getDoctorDetail: (id: string | number) => {
    return Axios().get<Doctor>(`${endpoint}/${id}`);
  },
};

export default doctorApi;
